export default {
  accountDfp: process.env.REACT_APP_DFP_ID || '1040536'
}



// WEBPACK FOOTER //
// ./src/redux/initial-state/google.js